import { FormControl, FormHelperText, InputLabel } from "@mui/material"
import { Font } from "components/shopFeatures/wizard/constants"
import { Field, useFormikContext } from "formik"
import { Select } from "formik-mui"
import React from "react"
import { useTypedSelector } from "store"
import styled from "styled-components"

const StyledContainer = styled.div`
  padding-bottom: ${(p) => p.theme.spacing(2)}px;
  margin-bottom: ${(p) => p.theme.spacing(0.5)}px;
`
const StyledFormControl = styled(FormControl)`
  margin-bottom: 0;
`
const StyledError = styled(FormHelperText).attrs({ error: true })`
  position: absolute;
`

const StyledField = styled(Field)`
  color: ${(p) => p?.theme?.colors?.disable};
  margin-top: 30px;
  select {
    padding-left: 20px !important;
  }
`

const StyledInputLabel = styled(InputLabel)<{ shrink?: boolean }>`
  font-family: ${Font.OENaPro};
  font-size: 12px;
  font-weight: 300;
  line-height: 16px;
  letter-spacing: 0em;
  transform: ${(props) =>
    props.shrink
      ? "translate(0px, 0px) scale(1)"
      : "translate(-10px, 24px) scale(1)"};
  transition: transform 0.2s ease-in-out;
`

const ShowRoomSelect = ({
  inputRef,
  showLabel,
}: {
  inputRef?: React.RefObject<HTMLSelectElement>
  showLabel?: boolean
}) => {
  const { showRooms } = useTypedSelector((state) => state.showRooms)

  const { errors, touched, values } = useFormikContext<{ showRoom: number }>()

  return (
    <StyledContainer>
      <StyledFormControl>
        {showLabel && (
          <StyledInputLabel
            htmlFor="showRoom"
            shrink={values.showRoom !== undefined}
          >
            *אולם תצוגה מועדף
          </StyledInputLabel>
        )}
        <StyledField
          component={Select}
          name="showRoom"
          id="showRoom"
          native
          inputRef={inputRef}
          aria-describedby="showRoom-helper-text"
        >
          <option value={0} disabled hidden>
            *אולם תצוגה מועדף
          </option>
          {showRooms.map((showRoom) => (
            <option key={showRoom.id} value={showRoom.id}>
              {showRoom.name}
            </option>
          ))}
        </StyledField>
      </StyledFormControl>

      {errors.showRoom && touched.showRoom && (
        <StyledError id="showRoom-helper-text">{errors.showRoom}</StyledError>
      )}
    </StyledContainer>
  )
}

export default ShowRoomSelect
